import Vue from 'vue'

export default {
  getServiceRequests ({ commit }, news) {
    return Vue.axios.get('/requests')
    .then(({ data }) => commit('ADD_REQUESTS', data))
  },
  updateServiceRequest ({ commit }, request) {
    return Vue.axios.put('/requests/service', { request })
  },
  updateConsultationRequest ({ commit }, request) {
    return Vue.axios.put('/requests/consultation', { request })
  },
  deleteServiceRequest ({ commit }, id) {
    return Vue.axios.delete(`/requests/service/${id}`)
    .then(({ data }) => commit('DELETE_SERVICE_REQUEST', id))
  },
  deleteConsultationRequest ({ commit }, id) {
    return Vue.axios.delete(`/requests/consultation/${id}`)
    .then(({ data }) => commit('DELETE_CONSULTATION_REQUEST', id))
  }
}



// WEBPACK FOOTER //
// ./src/store/actions/serviceRequests.js